import wa from 'apps/analytics/services/waEventEmitter';
import PageEvents from 'apps/header/models/PageEvents';
import PageEventFields from 'apps/header/models/PageEventFields';
import { gtm } from 'apps/gtm';

export function reportTopTabClicked(link, name) {
  return (dispatch, getState, { network }) => {
    let redirect = () => {};
    if (link) {
      redirect = () => {
        network.redirectTo({ to: link });
      };
    }
    wa.triggerPageEventWithDescription(
      PageEvents.TOP_TAB_CLICKED,
      { [PageEventFields.BANNER_LINK]: link, [PageEventFields.ITEM_TAG]: name },
      redirect,
    );
    gtm.trigger('gtm:navigationEvent', { menuType: 'Header top menu', topMenuItem: name });
  };
}
